<template>
  <article>
    <div class="filter mt-20">
      <div class="filter__item">
        <adSelect v-model="filters.adid" :lists.sync="adLists"/>
      </div>
      <div class="filter__item">
        <div class="filter__name">口令墙：</div>
        <watchSelect v-model="filters.awid" :lists.sync="watchwordLists"/>
      </div>
      <div class="filter__item">
        <div class="filter__name">购买类型：</div>
        <el-select class="filter__input" size="mini" v-model="filters.purchase">
          <el-option :label="item.name" :value="item.value" v-for="(item, index) in purchaseList" :key="index"></el-option>
        </el-select>
      </div>
      <div class="filter__item">
        <div class="filter__name">申请人：</div>
        <operSelect v-model="filters.opid" :lists.sync="operLists"/>
      </div>
      <div class="filter__item">
        <div class="filter__name">人群：</div>
        <el-select class="filter__input" size="mini" v-model="filters.people">
          <el-option :label="item.name" :value="item.value" v-for="(item, index) in peopleList" :key="index"></el-option>
        </el-select>
      </div>

      <div class="filter__item">
        <div class="filter__name">用户UID：</div>
        <el-input v-model="filters.uid" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">订单ID：</div>
        <el-input v-model="filters.oid" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <!--
      <div class="ml-auto">
        <button class="blue-small-btn"  @click="dialogVisible = true">一键汇总</button>
        <el-dialog
          title="提示"
          :visible.sync="dialogVisible"
          width="30%"
          center>
          <span>是否立即汇总订单，生成兑换记录</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="summaryOrderExchange">确 定</el-button>
          </span>
        </el-dialog>
      </div>
      -->
    </div>
    <div class="flex jcb mt-20">
      <div class="filter">
        <button class="white-small-btn mr-20"  @click="toggleSelection(lists)">全选</button>
        <button class="white-small-btn mr-20"  @click="toggleSelection()">取消选择</button>
        <div class="mr-20" v-if="filters.status === 0 || filters.status === 4">
          <button class="white-small-btn"  @click="multiDialog = true">个人批量打款</button>
          <el-dialog
            title="提示"
            :visible.sync="multiDialog"
            width="30%"
            center>
            <span>是否导出兑换记录，使用个人批量打款</span>
            <span slot="footer" class="dialog-footer">
              <el-button @click="multiDialog = false">取 消</el-button>
              <el-button type="primary" @click="downloadPersonMultiExchange">确 定</el-button>
            </span>
          </el-dialog>
        </div>
        <button class="white-small-btn mr-20" @click="editMultiExchange" v-if="filters.status === 0 || filters.status === 4">合并打款</button>
        <!--
        <button class="blue-small-btn mr-20" @click="multiExchangeApply = 1 ^ multiExchangeApply" v-if="filters.status === 0 || filters.status === 4">合并打款</button>
        -->
        <div class="filter__item" v-if="filters.status === 1">
          <button class="blue-small-btn mr-10" @click="uploadDialog = !uploadDialog">上传</button>
        </div>
      </div>
      <div>
        <button class="ml-10" :class="{'blue-small-btn': item.status, 'white-small-btn': !item.status}" v-for="(item, index) in statusList" :key="index" @click="changeStatus(index)">{{item.name}}</button>
      </div>
    </div>
    <div class="flex jcb mt-20" v-if="filters.status === 0 || filters.status === 4">
      <div class="flex aic">
        <div class="mr-20">
          <button class="blue-small-btn"  @click="dialogVisible = true">一键汇总</button>
          <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="30%"
            center>
            <span>是否立即汇总订单，生成兑换记录</span>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="summaryOrderExchange">确 定</el-button>
            </span>
          </el-dialog>
        </div>
        <div class="mr-20">选择支付宝：</div>
        <el-radio-group v-model="pay_account">
          <el-radio :label="1" border size="small">极推支付宝</el-radio>
          <el-radio :label="2" border size="small">有只喵支付宝</el-radio>
        </el-radio-group>
      </div>
      <div v-if="!multiExchangeApply">
        <button class="ml-10" :class="{'blue-small-btn': item.status, 'white-small-btn': !item.status}" v-for="(item, index) in handleList" :key="index" @click="changeHandle(index)">{{item.name}}</button>
        <button class="blue-small-btn ml-10" @click="adExchangeUpdate">提交</button>
      </div>
      <div v-if="multiExchangeApply">
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全部选择</el-checkbox>
        <button class="ml-10" :class="{'blue-small-btn': multiExchangeDialog, 'white-small-btn': !multiExchangeDialog}" @click="editMultiExchange" v-if="multiExchangeApply">提交</button>
      </div>
    </div>
    <el-table ref="dataTable" :data="lists" highlight-current-row v-loading="listLoading" style="width: 100%;" class="mt-30" height="600" :summary-method="getSummaries" show-summary @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="60"></el-table-column>
      <el-table-column prop="eid" label="兑换ID" width="" align="center">
      </el-table-column>
      <el-table-column prop="adid" label="广告" width="" align="center">
        <template slot-scope="scope">
          <div @dblclick="setFiltersValue('adid', scope.row.adid)">{{scope.row.title}}({{scope.row.adid}})</div>
        </template>
      </el-table-column>
      <el-table-column prop="awid" label="口令" width="" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.awid !== 0" @dblclick="setFiltersValue('awid', scope.row.awid)">{{scope.row.watchword_title}}({{scope.row.awid}})</div>
        </template>
      </el-table-column>
      <el-table-column prop="uid" label="用户" width="" align="center">
        <template slot-scope="scope">
          <router-link :to="{path: '/adUserDetail', query: {uid: scope.row.uid}}">{{scope.row.nickname}}({{scope.row.uid}})</router-link>
        </template>
      </el-table-column>
      <el-table-column prop="method" label="支付方式" width="" align="center">
        <template slot-scope="scope">
          <div v-if="filters.status !== 0 && filters.status !== 4">
            <div v-if="scope.row.method == 1">手动打款</div>
            <div v-if="scope.row.method == 0">企业支付宝</div>
          </div>
          <div v-else>
            <el-button type="primary" size="small" @click="displayHandDialog(scope.$index, scope.row.eid)">手动打款</el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="pay_account" label="支付账户" width="" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.pay_account == 2">有只喵支付宝</div>
          <div v-if="scope.row.pay_account == 1">极推支付宝</div>
          <div v-if="scope.row.pay_account == 0">个人号</div>
        </template>
      </el-table-column>
      <el-table-column prop="user" label="真实名字" width="" align="center">
        <template slot-scope="scope">
          <div @dblclick="setFiltersValue('uid', scope.row.uid)">{{scope.row.user}}</div>
        </template>
      </el-table-column>
      <!--
      <el-table-column prop="" label="类型" width="" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.type == 1">银行卡</div>
          <div v-if="scope.row.type == 0">支付宝</div>
        </template>
      </el-table-column>
      -->
      <el-table-column prop="account" label="账号" width="" align="center">
      </el-table-column>
      <el-table-column prop="purchase" label="购买类型" width="" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.purchase == 0">需要返现</div>
          <div v-if="scope.row.purchase == 1">直接折扣</div>
          <div v-if="scope.row.purchase == 2">假单</div>
          <div v-if="scope.row.purchase == 3">囤货</div>
        </template>
      </el-table-column>
      <el-table-column prop="payment" label="订单金额" width="" align="center">
      </el-table-column>
      <el-table-column prop="estimate_commission" label="预估佣金" width="" align="center">
      </el-table-column>
      <el-table-column prop="amount" label="打款金额" width="" align="center">
      </el-table-column>
      <el-table-column prop="agency_fees" label="拍手费" width="" align="center">
      </el-table-column>
      <el-table-column prop="estimate_profit" label="预估利润" width="" align="center">
      </el-table-column>
      <el-table-column prop="profit" label="利润" width="" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.profit < 0">
            <router-link class="fc-red pointer" target="_blank" :to="{path: '/adOrder', query: {oids: scope.row.oids}}">{{scope.row.profit}}</router-link>
          </div>
          <div v-else>
            {{scope.row.profit}}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="oids" label="申请订单号" width="" align="center">
        <template slot-scope="scope">
          <div class="flex jcc">
            <router-link class="underline fc-blue pointer" target="_blank" :to="{path: '/adOrder', query: {oids: scope.row.oids}}">{{scope.row.oids}}</router-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" width="" align="center" sortable>
        <template slot-scope="scope">
          <div v-if="scope.row.remark">
            <span class="underline fc-blue pointer" @click="editRemark(scope.$index)">{{scope.row.remark}}</span>

          </div>
          <div v-else>
            <i class="el-icon-edit" @click="editRemark(scope.$index)"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="create_time" label="创建时间" align="center">
        <template slot-scope="scope">
          <div v-html="formatTimeStamp(scope.row.create_time)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="last_edit" label="编辑时间" align="center">
        <template slot-scope="scope">
          <div v-html="formatTimeStamp(scope.row.last_edit)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="" label="状态" width="120" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.status == 4">兑换失败</div>
          <div v-if="scope.row.status == 3">兑换成功</div>
          <div v-if="scope.row.status == 2">拒绝兑换</div>
          <div v-if="scope.row.status == 1">审核通过</div>
          <div v-if="scope.row.status == 0">等待审核</div>
        </template>
      </el-table-column>
      <el-table-column prop="response" label="结果" width="140" align="center" v-if="filters.status === 4">
      </el-table-column>
      <el-table-column prop="" label="操作" width="160" fixed="right" align="center" v-if="filters.status === 0 || filters.status === 4">
        <template slot-scope="scope">
          <div v-if="!multiExchangeApply">
            <el-radio-group v-model="scope.row.isChoose">
              <el-radio :label="1">通过</el-radio>
              <el-radio :label="0">拒绝</el-radio>
            </el-radio-group>
          </div>
          <div v-else>
            <el-checkbox v-model="scope.row.isCheck" @change="handleCheckedOrderChange">合并</el-checkbox>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, pager, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="filters.l" :page-sizes="[20, 50, 100, 200]" :total="filters.total" :current-page="filters.p" class="tac mt-36 pb-36">
    </el-pagination>
    <el-dialog :visible.sync="remarkDialog" size="tiny" width="600px">
      <div class="flex fdc aic">
        <div class="dataForm">
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">备注:</div>
            <el-input class="dataForm__input" v-model="detail.remark" size="mini"></el-input>
          </div>
          <div class="flex mt-30">
            <div class="blue-large-btn mr-20" @click="adExchangeEdit">保存</div>
            <div class="gray-large-btn" @click="remarkDialog = false">取消</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="创建收支请款记录"
      :visible.sync="handDialogVisible"
      width="30%"
      center>

      <div class="flex fdc aic">
        <div class="dataForm">
          <div class="dataForm__item">
            <div class="dataForm__name">兑换ID:</div>
            <div class="">{{exchange_info.eid}}</div>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">用户:</div>
            <div class="">{{exchange_info.nickname}}({{exchange_info.uid}})</div>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">广告:</div>
            <div class="">{{exchange_info.title}}({{exchange_info.adid}})</div>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">请款金额:</div>
            <div class="">{{exchange_info.amount}}</div>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name ml40">收款二维码</div>
            <div class="headimg-container relative" style="width:250px">
              <uploadHeadImage :url.sync="exchange_info.account" :itype="5"></uploadHeadImage>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-20">
        <span>是否选择手动打款，确定后将需要去收支列表打款</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editHand">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="合并打款" :visible.sync="multiExchangeDialog" size="tiny" width="800px" center>
      <div class="flex fdc aic">
        <div class="dataForm">
          <div class="dataForm__item">
            <div class="dataForm__name">兑换ID集合:</div>
            <el-input class="dataForm__input" v-model="multiExchangeInfo.eids" size="mini" disabled="true"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">总实付金:</div>
            <el-input class="dataForm__input" v-model="multiExchangeInfo.payment" size="mini" disabled="true"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">用户ID:</div>
            <div class="">{{multiExchangeInfo.uid}}</div>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">打款总金额:</div>
            <div class="">{{multiExchangeInfo.amount}}</div>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">支付方式:</div>
            <el-radio-group v-model="multiExchangeInfo.pay_type" @input="changePayType">
              <div class="dib mr-20">
                <el-radio :label="0">银行卡</el-radio>
                <el-radio :label="1">支付宝</el-radio>
                <el-radio :label="2">微信</el-radio>
              </div>
            </el-radio-group>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name ml40">收款账号</div>
            <el-input type="textarea" v-model="multiExchangeInfo.account" rows=4 placeholder="" size="mini" class="dataForm__input" width="200px"></el-input>
            <div class="headimg-container relative" style="width:250px">
              <uploadHeadImage :url.sync="multiExchangeInfo.account" :itype="5"></uploadHeadImage>
            </div>
          </div>
          <div class="flex mt-30">
            <div class="blue-large-btn mr-20" @click="adMultiExchangeUpdate">保存</div>
            <div class="gray-large-btn" @click="multiExchangeDialog = false">取消</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="个人批量打款结果上传" :visible.sync="uploadDialog" size="tiny" width="600px" center>
      <div class="flex fdc aic">
        <div class="dataForm">
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">导入数据：</div>
            <el-upload
              ref="kttUpload"
              class="upload-demo"
              drag
              action=""
              :limit="1"
              accept=".xls,.xlsx"
              :on-success="uploadSuccess"
              :on-error="uploadError"
              :http-request="averExchangeUpload"
              >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              <div class="el-upload__tip" slot="tip">只能上传.xls和.xlsx文件</div>
            </el-upload>
          </div>
        </div>
      </div>
    </el-dialog>

  </article>
</template>

<script>
import mixinList from '../../../mixins/list'
import util from '../../../script/util'
import {adExchangeLists, adExchangeUpdate, adMultiExchangeUpdate, summaryOrderExchange, adExchangeEdit, averExchangeUpload, downloadAverPersonMultiExchange} from '../../../api/api'
import uploadHeadImage from '../../../components/uploadImage.vue'
import adSelect from '../../../components/data-select/adSelect.vue'
import operSelect from '../../../components/data-select/operSelect.vue'
import watchSelect from '../../../components/data-select/watchSelect.vue'
import taskSelect from '../../../components/data-select/taskSelect.vue'
export default {
  name: 'adExchange',
  mixins: [mixinList],
  components: {
    uploadHeadImage,
    adSelect,
    operSelect,
    watchSelect,
    taskSelect
  },
  data () {
    return {
      multipleSelection: [],
      lists: [],
      operLists: [],
      adLists: [],
      watchwordLists: [],
      listLoading: false,
      dialogVisible: false,
      multiDialog: false,
      remarkDialog: false,
      uploadDialog: false,
      handDialogVisible: false,
      multiExchangeApply: false,
      multiExchangeDialog: false,
      filters: {
        p: 1,
        l: 20,
        status: '',
        eids: '',
        oid: '',
        opid: '',
        total: 0,
        uid: '',
        adid: '',
        awid: '',
        purchase: '',
        people: ''
      },
      detail: {
        eid: '',
        remark: ''
      },
      pay_account: 1,
      exchange_info: {
        eid: '',
        uid: '',
        nickname: '',
        adid: '',
        title: '',
        amount: '',
        account: ''
      },
      checkAll: false,
      isIndeterminate: false,
      checkedCount: 0,
      multiExchangeInfo: {
        eids: '',
        uid: '',
        nickname: '',
        title: '',
        amount: '',
        account: '',
        pay_type: 0,
        alipay: '',
        wechat: '',
        bank: ''
      },
      // 状态按钮
      statusList: [
        {
          name: '所有',
          value: '',
          status: 1
        },
        {
          name: '等待审核',
          value: 0,
          status: 0
        },
        {
          name: '审核通过',
          value: 1,
          status: 0
        },
        {
          name: '拒绝兑换',
          value: 2,
          status: 0
        },
        {
          name: '兑换成功',
          value: 3,
          status: 0
        },
        {
          name: '兑换失败',
          value: 4,
          status: 0
        }
      ],
      purchaseList: [
        {
          name: '所有',
          value: ''
        },
        {
          name: '需要返款',
          value: 0
        },
        {
          name: '囤货',
          value: 3
        }
      ],
      peopleList: [
        {
          name: '所有',
          value: ''
        },
        {
          name: '用户们',
          value: 1
        },
        {
          name: '自家们 ',
          value: 2
        }
      ],
      // 操作按钮
      handleList: [
        {
          name: '全部通过',
          value: 1,
          status: 0
        },
        {
          name: '全部拒绝',
          value: 2,
          status: 0
        }
      ]
    }
  },
  methods: {
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.dataTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.dataTable.clearSelection()
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    // 格式化时间
    formatTimeStamp (time) {
      return util.formatTimeStamp(time)
    },
    handleSizeChange (val) {
      this.filters.l = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.filters.p = val
      this.getList()
    },
    opertorChange () {
      if (this.filters.opid !== '') {
        this.operLists.forEach((item) => {
          if (this.filters.opid === item.opid) {
            this.filters.uid = item.uid
          }
        })
      } else {
        this.filters.uid = ''
      }
    },
    conditionChange () {
      this.filters.p = 1
      this.getList()
    },
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (['amount', 'payment', 'commission', 'final_payment', 'agency_fees'].includes(column.property)) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          sums[index] = sums[index].toFixed(2)
        } else {
          sums[index] = 'N/A'
        }
      })

      return sums
    },
    handleCheckAllChange (val) {
      this.lists.forEach((item) => {
        item.isCheck = val
        item.isChoose = ''
      })

      this.checkedCount = val ? this.lists.length : 0
      this.isIndeterminate = false
    },
    handleCheckedOrderChange (val) {
      this.checkedCount = this.checkedCount + (val ? 1 : -1)
      this.checkAll = this.checkedCount === this.lists.length
      this.isIndeterminate = this.checkedCount > 0 && this.checkedCount < this.lists.length
    },
    summaryOrderExchange () {
      summaryOrderExchange({}).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.dialogVisible = false
        }
      })
    },
    setFiltersValue (key, value) {
      if (this.filters[key] === '') {
        this.filters[key] = value
      } else {
        this.filters[key] = ''
      }
    },
    uploadSuccess (res) {
      // 去掉文件列表
      this.$refs['kttUpload'].clearFiles()
    },
    uploadError (res) {
      // 去掉文件列表
      this.$refs['kttUpload'].clearFiles()
    },
    averExchangeUpload (params) {
      let file = params.file

      // 使用FormData传参数和文件
      let form = new FormData()

      // 添加键值对
      form.append('file', file)

      averExchangeUpload(form).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '提交成功',
            type: 'success'
          })
          this.getList()
          this.uploadDialog = false
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    downloadPersonMultiExchange () {
      let eidLists = []
      console.log('multipleSelection', this.multipleSelection)
      this.multipleSelection.forEach(item => {
        eidLists.push(item['eid'])
      })

      let content = ''

      if (eidLists.length === 0) {
        content = '请选择需要打款的记录'
      }

      if (content) {
        this.$notify({
          title: '失败',
          message: content,
          type: 'error'
        })
        return
      }

      let link = downloadAverPersonMultiExchange + '?eids=' + eidLists.join('|')

      setTimeout(() => {
        this.multiDialog = false

        this.getList()
      }, 2000)

      window.open(link, 'a')
    },
    getList () {
      let filters = this.filters
      let params = {
        // status: filters.status,
        p: filters.p,
        l: filters.l
      }
      if (filters.eids !== '') {
        params.eids = filters.eids
      }
      if (filters.status !== '') {
        params.status = filters.status
      }
      if (filters.adid !== '') {
        params.adid = filters.adid
      }
      if (filters.awid !== '') {
        params.awid = filters.awid
      }
      if (filters.uid !== '') {
        params.uid = filters.uid
      }
      if (filters.purchase !== '') {
        params.purchase = filters.purchase
      }
      if (filters.people !== '') {
        params.people = filters.people
      }
      if (filters.oid !== '') {
        params.oid = filters.oid
      }
      this.listLoading = true
      adExchangeLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          data.d.lists.forEach((item) => {
            item.isChoose = ''
            item.isCheck = false
          })
          this.lists = data.d.lists
          this.filters.total = data.d.total
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.$notify({
          title: '失败',
          message: '服务器出错了',
          type: 'error'
        })
      })
    },
    adExchangeEdit () {
      let params = {
        eid: this.detail.eid,
        remark: this.detail.remark
      }

      adExchangeEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '提交成功',
            type: 'success'
          })
          this.remarkDialog = false
          this.getList()
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    adExchangeUpdate (success = '') {
      let lists = this.lists
      let accept = []
      let reject = []
      lists.forEach((item) => {
        if (item.isChoose === 1) {
          accept.push(item.eid)
        }
        if (item.isChoose === 0) {
          reject.push(item.eid)
        }
      })

      let params = {
        pay_account: this.pay_account,
        accept: accept.join('|'),
        reject: reject.join('|')
      }

      if (success !== '') {
        params.success = success
        params.account = this.exchange_info.account
      }

      adExchangeUpdate(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '提交成功',
            type: 'success'
          })
          this.getList()
          this.handDialogVisible = false
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    adMultiExchangeUpdate () {
      let params = {
        eids: this.multiExchangeInfo.eids,
        uid: this.multiExchangeInfo.uid,
        account: this.multiExchangeInfo.account
      }

      let content = ''

      if (params.eids === '') {
        content = '请选择兑换记录'
      }

      if (params.account === '') {
        content = '请填写支付账号'
      }

      if (content) {
        this.$notify({
          title: '失败',
          message: content,
          type: 'error'
        })
        return
      }

      adMultiExchangeUpdate(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '提交成功',
            type: 'success'
          })
          this.getList()
          this.handDialogVisible = false
          this.multiExchangeDialog = false
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    changeStatus (index) {
      this.statusList.forEach(item => {
        item.status = 0
      })
      this.statusList[index].status = 1
      this.filters.status = this.statusList[index].value

      this.filters.p = 1
      this.getList()
    },
    displayHandDialog (index, eid) {
      this.detail.eid = eid
      this.handDialogVisible = true
      this.lists.forEach((item) => {
        item.isChoose = ''
      })

      for (let key in this.exchange_info) {
        this.exchange_info[key] = this.lists[index][key]
      }
      this.exchange_info.account = ''
    },
    editRemark (index) {
      this.remarkDialog = true
      this.detail.remark = this.lists[index].remark
      this.detail.eid = this.lists[index].eid
    },
    editHand (eid) {
      if (this.exchange_info.account === '') {
        this.$notify({
          title: '收款二维码没有传',
          type: 'error'
        })
        return
      }
      this.adExchangeUpdate(this.detail.eid)
      this.handDialogVisible = false
    },
    changeHandle (index) {
      this.handleList.forEach(item => {
        item.status = 0
      })
      this.handleList[index].status = 1
      switch (this.handleList[index].value) {
        case 1: // 全部通过
          this.lists.forEach((item) => {
            item.isChoose = 1
          })
          break
        case 2: // 全部拒绝
          this.lists.forEach((item) => {
            item.isChoose = 0
          })
          break
      }
    },
    changePayType () {
      let payType = parseInt(this.multiExchangeInfo.pay_type)

      if (payType === 0) {
        this.multiExchangeInfo.account = this.multiExchangeInfo.bank
      } else if (payType === 1) {
        this.multiExchangeInfo.account = this.multiExchangeInfo.alipay
      } else if (payType === 2) {
        this.multiExchangeInfo.account = this.multiExchangeInfo.wechat
      }
    },
    editMultiExchange () {
      let content = ''
      if (this.filters.uid === '' || this.filters.uid === 0) {
        content = '请先填写用户ID'
      }

      if (this.multipleSelection.length === 0) {
        content = '请选择需要打款的记录'
      }

      if (content) {
        this.$notify({
          title: '失败',
          message: content,
          type: 'error'
        })
        return
      }

      this.multiExchangeDialog = true
      let payment = 0
      let amount = 0

      let consistent = []
      this.multipleSelection.forEach((item) => {
        consistent.push(item.eid)
        amount = amount += item.amount
        payment = payment += item.payment
      })

      // let lists = this.lists
      // let consistent = []
      // lists.forEach((item) => {
      //   item.isChoose = ''

      //   if (item.isCheck === true) {
      //     consistent.push(item.eid)
      //     amount = amount += item.amount
      //     payment = payment += item.payment
      //   }
      // })

      for (let key in this.multiExchangeInfo) {
        this.multiExchangeInfo[key] = ''
      }

      this.multiExchangeInfo.eids = consistent.join('|')
      this.multiExchangeInfo.uid = this.filters.uid
      this.multiExchangeInfo.amount = amount
      this.multiExchangeInfo.payment = payment
      this.multiExchangeInfo.pay_type = 0

      if (this.filters.opid !== '') {
        this.operLists.forEach((item) => {
          if (parseInt(this.filters.opid) === item.opid) {
            this.multiExchangeInfo.alipay = item.alipay
            this.multiExchangeInfo.wechat = item.wechat
            this.multiExchangeInfo.bank = item.bank
            this.multiExchangeInfo.account = item.bank
          }
        })
      }
    }
  },
  mounted () {
    this.filters.eids = this.$route.query.eids || ''
    if (this.filters.eids === '') {
      this.changeStatus(1)
    } else {
      this.getList()
    }
  },
  updated () {
    this.$nextTick(() => {
      this.$refs['dataTable'].doLayout()
      this.$refs['dataTable'].bodyWrapper.scrollTop = 0
    })
  },
  watch: {
    'filters.uid': 'conditionChange',
    'filters.adid': 'conditionChange',
    'filters.awid': 'conditionChange',
    'filters.opid': 'opertorChange',
    'filters.purchase': 'conditionChange',
    'filters.people': 'conditionChange',
    'filters.oid': 'conditionChange'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/module/ad/adExchange.vue